import {Component} from '@angular/core';

@Component({
    selector: 'release-notes',
    templateUrl: './release-notes.component.html',


})

export class ReleaseNotesComponent {

}


// WEBPACK FOOTER //
// ./src/app/release-notes/release-notes.component.ts